import { returnsDefaultWeightByZoneSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as z from "zod";

export const saveDefaultRateTable = {
  name: "saveDefaultRateTable" as const,
  input: z.object({ rateTable: returnsDefaultWeightByZoneSchema }),
  output: z.object({ rateTables: z.array(returnsDefaultWeightByZoneSchema) }),
};
